import { withProps } from 'recompose';
import { prop } from 'ramda';
import { useGameConfigurationSelector } from 'js/store/hooks';

export const withAvailableGames = withProps(
    ({ gameCodes }) => {
        const games = useGameConfigurationSelector(prop('games'));
        const availableGames = gameCodes.filter(code => games?.[code]);

        return {
            gameCodes: availableGames
        };
    }
);
